// @flow
import type { EventContent } from "redux/api-types/EventContent";

export type EventContentFormFields = {
  name: string,
  tagline: string,
  description: string,
  type: string,
  topics: Array<string>,
  primaryImageUrl: string,
  secondaryImageUrl: string,
  coverImageUrl: string,
};

type EventContentFlags = {
  hasLiveFire: boolean,
  isWomenOnly: boolean,
  isMultiDay: boolean,
};

export const getEventContentFlags = (
  content: ?EventContent
): EventContentFlags => ({
  hasLiveFire: content?.attributes.hasLiveFire ?? false,
  isWomenOnly: content?.attributes.isWomensOnly ?? false,
  isMultiDay: content?.attributes.isMultiDay ?? false,
});

const EVENT_TYPE_TO_POST_TYPE: { [string]: string } = {
  "legal-seminar": "legal-seminar",
  "member-night": "member-night",
  "uscca-community-event": "uscca-community-event",
  "special-event": "special-event",
  national: "national",
  ope: "ope",
  class: "class",
  ccw: "class",
};

export const mapEventTypeToPostType = (eventType: string): string =>
  EVENT_TYPE_TO_POST_TYPE[eventType] || "class";

export const stripHtml = (value: ?string): string => {
  if (!value) {
    return "";
  }

  const htmlWithLineBreaks = value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<li\b[^>]*>/gi, "- ")
    .replace(/<\/(?:p|div|li|h[1-6]|blockquote)>/gi, "\n\n");
  const document = new DOMParser().parseFromString(
    htmlWithLineBreaks,
    "text/html"
  );

  document
    .querySelectorAll("script, style")
    .forEach((element: Element): mixed => {
      element.remove();
    });

  return (document.body.textContent || "")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export const getEventContentFormFields = (
  content: EventContent
): EventContentFormFields => {
  const { attributes } = content;

  return {
    name: attributes.name || "",
    tagline: attributes.tagline || "",
    description: stripHtml(attributes.description),
    type: mapEventTypeToPostType(attributes.eventType),
    topics: attributes.topics || [],
    primaryImageUrl: attributes.primaryImageUrl || "",
    secondaryImageUrl: attributes.secondaryImageUrl || "",
    coverImageUrl: attributes.coverImageUrl || "",
  };
};
